/** 菜单配置 */
// import util from '@/libs/util';
// import i18n from './i18n';
// const LAN = util.cookies.get(`gd-lang`) || VUE_APP_I18N_LOCALE;
// const Lan = i18n.messages[LAN];

// 顶栏导航配置
const headerMenuConfig = [
  {
    path: '/home',
    name: '首页',
    enName: 'Home',
    // children: [
    //     {
    //         path: '',
    //         name: '查询'
    //     }
    // ]
  },
  {
    path: '/product',
    name: '产品服务',
    enName: 'Products & Services',
  },
  {
    path: '/about',
    name: '关于我们',
    enName: 'About Us',
  },
  {
    path: '/support',
    name: '技术支持',
    enName: 'Technical Support',
  },
  {
    path: '/contact',
    name: '联系我们',
    enName: 'Contact Us',
  }
];

export {headerMenuConfig};



// WEBPACK FOOTER //
// ./src/menuConfig.js